import { Trash2 } from "@tamagui/lucide-icons";
import { observer } from "mobx-react-lite";
import React from "react";
import { XStack } from "tamagui";
import { BodyTextarea } from "../../../ui/Body";
import { Box } from "../../../ui/Box";
import { Group } from "../../../ui/Group";
import { Input } from "../../../ui/InputNew";
import { Label } from "../../../ui/Label";
import { PopoverConfirm } from "../../../ui/PopoverConfirm";
import type { BusinessCustomerModel } from "../customers/BusinessCustomerModel";
import { BusinessInfoRow } from "./BusinessInfoRow";

export const BusinessAdminProfileQuestions = observer(
  ({ customer }: { customer: BusinessCustomerModel }) => {
    const profileQuestions = customer.data.profileQuestions;

    return (
      <Box gap="$large">
        <BusinessInfoRow
          title={
            "Add profile questions for usage in your templates and events."
          }
        />

        <Label>Profile questions ({profileQuestions.length})</Label>

        <Group>
          {profileQuestions.map((question) => {
            return (
              <XStack
                key={question.uid}
                gap={"$medium"}
                justifyContent={"space-between"}
                alignItems={"center"}
                width={"100%"}
              >
                <BodyTextarea
                  placeholder="Add question..."
                  submitOnEnter
                  blurOnSubmit
                  flex={1}
                  onSubmitEditing={(e) =>
                    customer.updateProfileQuestion({
                      ...question,
                      question: e.nativeEvent.text.trim(),
                    })
                  }
                  defaultValue={question.question}
                />
                <XStack gap={"$medium"}>
                  <PopoverConfirm
                    onConfirm={() => {
                      customer.removeProfileQuestion(question);
                    }}
                  >
                    <Trash2 size={"$size.normal"} color={"$muted"} />
                  </PopoverConfirm>
                </XStack>
              </XStack>
            );
          })}
        </Group>
        <Input
          placeholder="Add Profile Question"
          type="border"
          clearOnSubmit
          onSubmitEditing={(event) => {
            customer.addProfileQuestion(event.nativeEvent.text.trim());
          }}
          submitOnEnter
        />
      </Box>
    );
  },
);
